import {
  ExpoRouterDemoBackButton,
  ExpoRouterDemoScreen,
  ExpoRouterDemoTitle,
} from '../../../components';

// ─────────────────────────────────────────────────────────────────────────────

export default function Page() {
  return (
    <ExpoRouterDemoScreen>
      <ExpoRouterDemoTitle>Add Credit</ExpoRouterDemoTitle>
      <ExpoRouterDemoBackButton href="/(modals)/credit" dismiss />
    </ExpoRouterDemoScreen>
  );
}
